<template>
  <component
    :is="elTag"
    class="s-radio-group"
    :class="row ? 's-radio-group-row' : 's-radio-group-column'"
    :data-qa="`${dataQa}-group`"
    role="radiogroup"
    @keydown="handleKeydown">
    <slot/>
  </component>
</template>
<script>
import emitter from '../../mixins/emitter'

const keyCode = Object.freeze({
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
})
/**
 * Группа Radio
 * @displayName RadioGroup
 */
export default {
  name: 'sRadioGroup',
  componentName: 'sRadioGroup',
  inject: {
    sFormItem: {
      default: ''
    }
  },
  mixins: [emitter],
  props: {
    /**
     * Значение
     */
    value: {
      type: [String, Number, Boolean],
    },
    /**
     * отключение
     */
    disabled: {
      type: Boolean,
    },
    /**
    * отобразить строкой
    */
    row: {
      type: Boolean,
    },
    /**
     * Ключ для автотестов
     * @ignore
     */    
    dataQa: {
      type: String,
      default: 'input'
    }
  },
  computed: {
    elTag() {
      let tag = (this.$vnode.data || {}).tag
      if (!tag || tag === 'component') { tag = 'div' }
      return tag
    },
  },
  created() {
    this.$on('handleChange', value => {
      this.$emit('change', value)
    })
  },
  mounted() {
    const radios = this.$el.querySelectorAll('[type=radio]')
    const firstLabel = this.$el.querySelectorAll('[role=radio]')[0]
    if (![].some.call(radios, radio => radio.checked) && firstLabel) {
      firstLabel.tabIndex = 0
    }
  },
  methods: {
    handleKeydown(e) {
      const target = e.target
      const className = target.nodeName === 'INPUT' ? '[type=radio]' : '[role=radio]'
      const radios = this.$el.querySelectorAll(className)
      const length = radios.length
      const index = [].indexOf.call(radios, target)
      const roleRadios = this.$el.querySelectorAll('[role=radio]')
      switch (e.keyCode) {
      case keyCode.LEFT:
      case keyCode.UP:
        e.stopPropagation()
        e.preventDefault()
        if (index === 0) {
          roleRadios[length - 1].click()
          roleRadios[length - 1].focus()
        } else {
          roleRadios[index - 1].click()
          roleRadios[index - 1].focus()
        }
        break
      case keyCode.RIGHT:
      case keyCode.DOWN:
        if (index === (length - 1)) {
          e.stopPropagation()
          e.preventDefault()
          roleRadios[0].click()
          roleRadios[0].focus()
        } else {
          roleRadios[index + 1].click()
          roleRadios[index + 1].focus()
        }
        break
      default:
        break
      }
    }
  },
  watch: {
    value() {
      this.dispatch('sFormItem', 's.form.change', [this.value])
    }
  }
}
</script>